import { useEffect } from 'react';
import I18n from 'I18n';
import { useUnifiedAccount } from 'unified-auth';
import PortalIdParser from 'PortalIdParser';
import { getAppNameByAppId } from '../../../../constants/AppIds';
export const UnifiedAccountIntegrationsServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthSucceeded,
  reconnectStarted
}) => {
  const portalId = PortalIdParser.get();
  const appId = (metadata === null || metadata === void 0 ? void 0 : metadata.appId) || 0;
  const accountId = (metadata === null || metadata === void 0 ? void 0 : metadata.accountId) || '0';
  const appName = getAppNameByAppId(appId) || I18n.text('reconnect.defaultAppName');
  const onComplete = response => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(String(response.accountId));
  };
  const onCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      message: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  const {
    isLoading,
    Modal,
    openModal,
    isOpen
  } = useUnifiedAccount({
    appId,
    appName,
    portalId,
    accountId: Number(accountId)
  }, {
    onComplete,
    onCancel
  });
  useEffect(() => {
    if (reconnectStarted && !isOpen && openModal) {
      openModal();
    }
  }, [reconnectStarted, isOpen, openModal]);
  return reconnectStarted && !isLoading && isOpen ? Modal : null;
};